import { useNavigate } from 'react-router-dom';
import { useCompanyRelativePath } from 'ogp/hooks';
import { routes } from 'Routes';
import { UserMutationOptions } from './use-get-workflow-actions.types';
import { useArchiveWorkflow } from '../use-archive-workflow/use-archive-workflow';

export const useGetWorkflowActionHandlers = (options?: { archiveOptions: UserMutationOptions }) => {
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();
  const archiveWorkflowMutation = useArchiveWorkflow(options?.archiveOptions);

  const handleEditWorkflow = (workflowId: string) => {
    navigate(generatePath(routes.WorkflowsEdit, { id: workflowId }));
  };

  const handleArchiveWorkflow = (workflowId: string) => {
    archiveWorkflowMutation.mutate(workflowId);
  };

  return {
    handleEditWorkflow,
    handleArchiveWorkflow,
  };
};
